
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps): any => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          success: 'bg-accent-success-500 text-white border-accent-success-600',
          error: 'bg-destructive text-destructive-foreground border-destructive',
          warning: 'bg-accent-warning-500 text-white border-accent-warning-600',
          info: 'bg-accent-info-500 text-white border-accent-info-600',
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
